/** Reads `.value` off an event target — works for both native inputs and
 * @material/web form-associated custom elements. */
export function inputValue(e: Event): string {
  return (e.target as unknown as { value: string }).value;
}

/** Reads `.checked` off an event target (checkbox / switch). */
export function inputChecked(e: Event): boolean {
  return (e.target as unknown as { checked: boolean }).checked;
}

export function errorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
